import { useState, useEffect, useCallback } from "react";
import { salesReportService } from "../../services";

export const useSalesReport = (initialParams = {}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [params, setParams] = useState(initialParams);

  const fetchSummary = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await salesReportService.getSummary(params);
      setData(result.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [params]);

  const fetchDetails = useCallback(
    async (page = 1) => {
      setLoading(true);
      setError(null);
      try {
        const result = await salesReportService.getDetails({ ...params, page });
        return result;
      } catch (err) {
        setError(err.message);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [params],
  );

  const fetchTopSelling = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await salesReportService.getTopSelling(params);
      return result.data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [params]);

  const fetchByHour = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await salesReportService.getByHour(params);
      return result.data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => {
    fetchSummary();
  }, [fetchSummary]);

  return {
    data,
    loading,
    error,
    params,
    setParams,
    refetch: fetchSummary,
    fetchDetails,
    fetchTopSelling,
    fetchByHour,
  };
};
